import runtimeEnv from '@mars/heroku-js-runtime-env';

// eslint-disable-next-line @typescript-eslint/naming-convention
const { REACT_APP_SOCKET_API_URL } = runtimeEnv();

export const socketApiUrl = REACT_APP_SOCKET_API_URL;
export const apiUrl = '/api/web/v1';
export const meApiUrl = '/me-api/v1';
export const bridgeApiUrl = '/bridge-api/v1';
export const apiOldUrl = '/api/v1';

export const signUpUrl = `${apiUrl}/signup`;
export const signUpEnterpriseDetailsUrl = `${apiUrl}/plan-details?hash=%token%`;
export const saveVisitorUrl = `${apiUrl}/visitors`;
export const groupUrl = `${apiUrl}/groups`;
export const referrerUrl = `${apiUrl}/referrer`;
export const contactFormUrl = `${apiUrl}/contact-us`;

export const sessionCookieUrl = `/sanctum/csrf-cookie`;
export const checkSessionUrl = `${apiUrl}/user-details`;
export const loginUrl = `${apiUrl}/signin`;
export const logoutUrl = `${apiUrl}/signout`;
export const forgotPasswordUrl = `${apiUrl}/forgot-password`;
export const resetPasswordUrl = `${apiUrl}/reset-password`;

export const healthCheckCSRFUrl = `${bridgeApiUrl}/healthCheck/csrf`;
export const healthCheckSessionUrl = `${bridgeApiUrl}/healthCheck/getSession`;
export const healthCheckLoginUrl = `${bridgeApiUrl}/healthCheck/signIn`;
export const healthCheckLogoutUrl = `${bridgeApiUrl}/healthCheck/signOut`;
export const healthCheckCertificateUrl = `${bridgeApiUrl}/healthCheck/certificate`;
export const healthCheckSettingsSwissOTPUrl = `${bridgeApiUrl}/healthCheck/settings/swissOTP`;

const healthCheckOrdersBaseUrl = `${bridgeApiUrl}/healthCheck/healthTest`;
export const healthCheckOrderedUrl = `${healthCheckOrdersBaseUrl}/ordered`;
export const healthCheckConfirmedUrl = `${healthCheckOrdersBaseUrl}/confirmed`;
export const healthCheckPendingUrl = `${healthCheckOrdersBaseUrl}/pending`;
export const healthCheckDoneUrl = `${healthCheckOrdersBaseUrl}/done`;
export const healthCheckExportCSVUrl = `${healthCheckOrdersBaseUrl}/%status%/export?`;
export const healthCheckDownloadCertificateUrl = `${healthCheckOrdersBaseUrl}/%id%/certificate`;

export const healthCheckOrderDetailsUrl = `${healthCheckOrdersBaseUrl}/%id%`;
export const healthCheckOrderPerformUrl = `${healthCheckOrderDetailsUrl}/perform`;
export const healthCheckOrderConfirmUrl = `${healthCheckOrderDetailsUrl}/confirm`;
export const healthResendCertificateUrl = `${healthCheckOrderDetailsUrl}/sendCertificate`;
export const healthCheckStatsUrl = `${healthCheckOrdersBaseUrl}/stats`;
export const healthCheckS3PresignedUrl = `${healthCheckOrderDetailsUrl}/presignedUrl`;
export const healthCheckOrderResultUrl = `${healthCheckOrderDetailsUrl}/result`;

export const visitorsUrl = `${apiUrl}/companies/%company_id%/visitors`;
export const visitorArchiveUrl = `${apiUrl}/companies/%company_id%/visitor-archives`;
export const visitorWithStatsFilterUrl = `${apiUrl}/companies/%company_id%/visitor-stats-listings`;
export const visitorsCsvUrl = `${apiUrl}/companies/%company_id%/visitors-csv`;
export const visitorInviteUrl = `${apiUrl}/invitations`;
export const visitorStatsUrl = `${apiUrl}/companies/%id%/visitor-stats`;
export const visitorArchiveStatsUrl = `${apiUrl}/companies/%id%/visitor-archives/stats`;
export const visitorDetailsUrl = `${apiUrl}/companies/%id%/visitors/%visitorId%`;
export const visitorManualCheckoutUrl = `${apiUrl}/companies/%id%/visitors/%visitorId%/visitor-checked-out`;

export const employeesUrl = `${apiUrl}/companies/%id%/employees`;
export const employeesCountUrl = `${apiUrl}/companies/%id%/employee-count`;
export const employeesArchiveUrl = `${apiUrl}/companies/%id%/employee-archives`;
export const employeesWithStatsFilterUrl = `${apiUrl}/companies/%id%/employee-stats-listings`;
export const employeeStatsUrl = `${apiUrl}/companies/%id%/employee-stats`;
export const employeeArchiveStatsUrl = `${apiUrl}/companies/%id%/employee-archives/stats`;
export const deleteEmployeeUrl = `${apiUrl}/companies/%id%/employees/%company_id%/remove-company`;
export const employeeDetailsUrl = `${apiUrl}/companies/%id%/employees/%employeeId%`;
export const employeeHealthUrl = `${apiUrl}/companies/%id%/employees/%employeeId%/health`;
export const employeeLogsUrl = `${apiUrl}/companies/%id%/employees/%employeeId%/logs`;
export const employeeFilteredLogsUrl = `${apiUrl}/companies/%id%/employees/%employeeId%/filter-logs`;
export const employeeManualCheckoutUrl = `${apiUrl}/companies/%id%/employees/%employeeId%/checked-out`;
export const pendingInvitationsUrl = `${apiUrl}/companies/%id%/pending-invitations`;
export const failedInvitationsUrl = `${apiUrl}/companies/%id%/failed-invitations`;
export const resendInvitationUrl = `${apiUrl}/companies/%id%/resend-invitations`;
export const deleteInvitationUrl = `${apiUrl}/companies/%id%/invitations/%invitation_id%`;
export const invitationDetailsUrl = `${apiUrl}/companies/%id%/invitations/%invitation_id%`;
export const locationsUrl = `${apiUrl}/companies/%id%/locations`;
export const completeRegistrationDetailsUrl = `${apiUrl}/locations?token=%token%`;
export const completeRegistrationMobileDetailsUrl = `${apiUrl}/user-companies?token=%token%`;
export const completeRegistrationUrl = `${apiUrl}/locations`;
export const addLocationUrl = `${apiUrl}/companies/%id%/locations`;
export const locationListingUrl = `${apiUrl}/companies/%id%/locations`;
export const locationDetailsUrl = `${apiUrl}/companies/%id%/locations/%location_id%`;
export const locationDetailsByQrUrl = `${apiUrl}/details-by-qr?qr_token=%qr%`;
export const locationUpdateUrl = `${apiUrl}/companies/%id%/locations/%location_id%`;
export const s3PresignedUrl = `${apiUrl}/presigned-put-url`;
export const invitationsViaCsvUrl = `${apiUrl}/invitations/via-csv`;
export const invitationsViaCsvBiomarkUrl = `${apiUrl}/csv-invitations`;
export const employeeGetPermissionsUrl = `${apiUrl}/companies/%company_id%/employees/%employee_id%/get-permissions`;
export const employeeChangePermissionsUrl = `${apiUrl}/companies/%company_id%/employees/%employee_id%/change-permissions`;
export const employeeCheckUrl = `${apiUrl}/notification-settings`;

export const eventsUrl = `${apiUrl}/companies/%company_id%/events`;
export const eventTypesUrl = `${apiUrl}/event-types`;
export const eventDetailsUrl = `${apiUrl}/companies/%company_id%/events/%event_id%`;
export const attendeesStatsUrl = `${apiUrl}/companies/%company_id%/events/%event_id%/attendees-stats`;
export const attendeesStatsOngoingUrl = `${apiUrl}/companies/%company_id%/events/%event_id%/ongoing-attendees-stats`;
export const attendeesListByStatsUrl = `${apiUrl}/companies/%company_id%/events/%event_id%/attendees-stats-listings`;
export const attendeesListByStatsOngoingUrl = `${apiUrl}/companies/%company_id%/events/%event_id%/ongoing-attendees-stats-listings`;
export const attendeesUrl = `${apiUrl}/companies/%company_id%/events/%event_id%/attendees`;

export const insightsUrl = `${apiUrl}/companies/%id%/insights`;

export const saveCardUrl = `${apiUrl}/companies/%id%/cards`;
export const savePlanUrl = `${apiUrl}/companies/%id%/plans`;
export const billingDetailsUrl = `${apiUrl}/companies/%id%/billings`;
export const companyUpdateUrl = `${apiUrl}/companies/%id%`;
export const checkPasswordUrl = `${apiUrl}/companies/%id%/check-password`;
export const invoicesUrl = `${apiUrl}/companies/invoices`;
export const exportEnquiryUrl = `${apiUrl}/companies/%id%/export`;

export const qrCodeUrl = `${meApiUrl}/place/qrcode`;
export const joinWaitListUrl = `${apiUrl}/waitlist`;

export const stripePublishableKeyUrl = `${apiUrl}/stripe-details`;
export const plansByCountryUrl = `${apiUrl}/plans-by-country`;

export const enquiryStatusUrl = `${apiUrl}/enquiry-status`;

export const countriesUrl = `${apiOldUrl}/phone-code`;
export const timezoneUrl = `${apiOldUrl}/countries/%country_code%/timezones`;

export const workspacesUrl = `${apiUrl}/workspaces`;

export const defaultHeaders = {};
